import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mt-2 ml-5" }
const _hoisted_2 = { class: "p-2 pl-0 pr-0 text-base" }
const _hoisted_3 = { class: "grid" }
const _hoisted_4 = { class: "col-fixed" }
const _hoisted_5 = { class: "col mt-1" }
const _hoisted_6 = { class: "font-semibold" }
const _hoisted_7 = {
  key: 0,
  class: "mt-2 w-full"
}

import { toRefs } from 'vue';

interface Props {
  message: string;
  details?: string[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarWarning',
  props: {
    message: {},
    details: {}
  },
  setup(__props: any) {

const props = __props;

const { message, details } = toRefs(props);

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Message = _resolveComponent("Message")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Message, {
      severity: "warn",
      closable: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_Icon, {
                name: "warning",
                class: "text-color-yellow-dark"
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(message)), 1),
                (_unref(details))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(details), (detail) => {
                        return (_openBlock(), _createElementBlock("ul", { key: detail }, [
                          _createElementVNode("li", null, _toDisplayString(detail), 1)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})